"use client"

import { connect } from "react-redux";
import React, { useContext, useState, useEffect, useRef } from 'react';

import { AuthProvider } from "../context";

import { Dropdown } from 'primereact/dropdown';
import { Accordion, AccordionTab } from 'primereact/accordion';

// Component Custum

import ContentCardOrganizator from './ContentCardOrganizator';

// Custom
import { GenericaSistemaService } from '../service/GenericaSistemaService';
import { PlantillaService } from '../service/PlantillaService';

import AuthStorage from '../storage/AuthStorage';
import AuthController from '../controller/AuthController';
//import './TabViewDemo.css';
import { TabMenu } from 'primereact/tabmenu';
import { TabView, TabPanel } from 'primereact/tabview';
import { Avatar } from 'primereact/avatar';
import { Panel } from 'primereact/panel';
import { Ripple } from 'primereact/ripple';
import { SplitButton } from 'primereact/splitbutton';
import { Toolbar } from 'primereact/toolbar';
import BreadcrumbBar from "../components/tabs/BreadcrumbBar";
import { selectTab2 } from "../components/tabs/tabsActions2";
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';

import { verifySubdomainBase, verifyUser } from '../routes/ConfigSubdomain';

const TemplateContent = React.forwardRef((props, ref) => {

    console.log("TemplateContent.js",);
    verifySubdomainBase();
    verifyUser();

    //console.log("DatoMaestro.js", hash,"Get Parameters", params.get("userId"), location);

    const codMenu = props.codMenu || '_';
    //console.log("codMenu, ", codMenu);

    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();

    const { userName, idEmpresa, idioma, sessionGUID } = userDetails;

    const authController = new AuthController();
    const genericaSistemaService = new GenericaSistemaService();


    //********************************************************************************************************* */
    // validado;

    const [etiquetasMenu, setEtiquetasMenu] = useState([]);
    const [metadaTipoGenerica, setMetadaTipoGenerica] = useState({ 'tc': '', 'ctiTexto': '' });
    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState({});
    const [visible, setVisible] = useState(props.visible);
    const [items, setItems] = useState([]);
    const [comodin, setComodin] = useState(0);
    const [visibleBottom, setVisibleBottom] = useState(false);
    const [windowSize, setWindowSize] = useState(getWindowSize());

    if (visible !== props.visible) {
        setVisible(props.visible);
    }

    const cargueInicialHecho = useRef(false);

    const tabs = useRef([]);
    let tabContainer = useRef([]);


    const plantillaService = new PlantillaService();


    /*
    
    selectedColumns.forEach(metaref => {

        console.log("metaref, ",metaref);
        
        if (metaref.columnRef!==null){

            switch (metaref.tipoDato){
                //metaref.columnRef.inputRef.current.checked=null
                case "boolean": ; break;
                //case "int": return ( <InputNumber id = {`filter${metadata.tg+'-'+metadata.campo}`} placeholder="Search..." style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e) }  />); break;
                //case "double": return ( <InputNumber id = {`filter${metadata.tg+'-'+metadata.campo}`} placeholder="Search..." mode="decimal" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e) }  />); break;
                default: metaref.columnRef.value=''; break;
            }
            
        }
        
    });
    */

    function GetTextoEtiqueta(etiqueta) {

        let et = etiquetasMenu.length > 0 ? etiquetasMenu.find(et => et.etiqueta === etiqueta) : undefined;
        return et !== undefined ? et.ctiTexto : "";
    }

    const selectedTipoGenericaSistemaTemplate = (option, props) => {
        if (option) {
            return (
                <div className="country-item">
                    <img alt='' src="images/flag/flag_placeholder.png" onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} className={'flag flag'} />
                    <div>{option.tg}</div>
                    <div>{option.ctiTexto}</div>
                </div>
            );
        }

        return (
            <span>
                {props.placeholder}
            </span>
        );
    }

    const tipoGenericaSistemaOptionTemplate = (option) => {
        return (
            <div className="country-item">
                <img alt='' src="images/flag/flag_placeholder.png" onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} className={`flag flag-${option.tg.toLowerCase()}`} />
                <div>{option.tg}</div>
                <div>{option.ctiTexto}</div>
            </div>
        );
    }

    // Fin de configuración del dropdown



    useEffect(() => {

        loadDatosBase();

        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };


    }, []) // eslint-disable-line react-hooks/exhaustive-deps    

    useEffect(() => {
        if (visible) {
            setTimeout(() => {
                let actionTab = selectTab2(codMenu + "Init");
                props.dispatch(actionTab);
            }, 1);
        }

    }, [visible]) // eslint-disable-line react-hooks/exhaustive-deps

    function getWindowSize() {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    }

    const loadDatosBase = async () => {

        if (codMenu !== "" && !cargueInicialHecho.current ) {

            cargueInicialHecho.current = true;
            
            await plantillaService.getEtiquetasMenu(codMenu, idEmpresa, idioma, userName).then(async data  => {

                
                setEtiquetasMenu(data);

                await genericaSistemaService.getTipoGenericaSistemaByMenu({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, codMenu).then(async data => {
                    setMetadaTipoGenerica(data.metadata);
                    //setTiposGenericas(data.data);

                    let selectedTg = data.data;

                    console.log("selectedTg,", tabs.current, selectedTg);

                    await genericaSistemaService.getTipoGenericaAsociadas({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTg.tg).then(data2 => {
                        //setMetadaTipoGenerica(data.metadata);

                        let tipoGenericasAsociadas = data2.data;
                        let tgAsociada;
                        let newItems = [...items];
                        for (let i = 0; i < tipoGenericasAsociadas.length; i++) {
                            tgAsociada = tipoGenericasAsociadas[i];
                            newItems.push({
                                label: tgAsociada.ctiTexto,
                                //icon: 'pi pi-refresh',
                                name: codMenu + "-" + tgAsociada.tg,
                                codMenu: codMenu,
                                level: 99,
                                selectedTipoGenerica: tgAsociada,
                                command: (e) => {
                                    addSubTabMenu(e)
                                }
                            },
                            );
                        }
                        setItems(newItems);

                    });

                    setTimeout(() => {
                        setSelectedTipoGenerica(data.data);

                        let newTabs = [...tabs.current];
                        newTabs.push({ name: codMenu + "Init", level: 1, codMenu: codMenu, label: selectedTg.ctiTexto, selectedTipoGenerica: selectedTg, component: ContentCardOrganizator });
                        tabs.current = newTabs;
                        let actionTab = selectTab2(codMenu + "Init");
                        props.dispatch(actionTab);

                    }, 1);

                });

            });
        }

    }

    const addSubTabMenu = (event) => {

        console.log("1addSubTabMenu");

        //let _tab =tabs.current.find(x=>x.name === event.item.name);
        let _maximoTabs = 7;

        let newTabstmp = [...tabs.current];

        let newTabstmp2 = newTabstmp.filter(y => y.codMenu === event.item.codMenu && y.level < event.item.level);

        if (newTabstmp2.length <= _maximoTabs) {

            let tgSelectedAnterior = newTabstmp.find(y => y.name === event.item.name);

            if (tgSelectedAnterior !== undefined) {
                newTabstmp2.push(tgSelectedAnterior);
            }
            else {
                newTabstmp2.push({ name: event.item.name, codMenu: codMenu, level: event.item.level, label: event.item.label, selectedTipoGenerica: event.item.selectedTipoGenerica, component: ContentCardOrganizator });
            }

            let actionTab = selectTab2(event.item.name);
            tabs.current = newTabstmp2;

            props.dispatch(actionTab);

            setTimeout(() => {

                setComodin(ant => ant + 1);

            }, 2);

        }
        else {
            console.log(`Excede el máximo de ${_maximoTabs} pestañas`);
            this.showMensaje(`Excede el máximo de ${_maximoTabs} pestañas`);
        }



    }

    const tabHeaderITemplate = (options) => {
        return (
            <button type="button" onClick={options.onClick} className={options.className}>
                <i className="pi pi-prime mr-2" />
                {options.titleElement}
            </button>
        );
    };

    const tabHeaderIITemplate = (options) => {
        return (
            <div className="flex align-items-center px-3" style={{ cursor: 'pointer' }} onClick={options.onClick}>
                <Avatar image="images/avatar/amyelsner.png" onImageError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} shape="circle" className="mx-2" />
                Amy Elsner
            </div>
        )
    };

    const leftToolbarTemplate = () => {
        return (
            <h5>  {GetTextoEtiqueta('TITULO_LISTATIPOGENERICAS')} </h5>
        )
    }
    const rightToolbarTemplate = () => {
        return (
            <Button icon="pi pi-arrow-up" onClick={() => setVisibleBottom(true)} className="mr-2" />
        )
    }

    const onAfterDeleteTab = (name) => {

        setTimeout(() => {

            let newTabs = [...tabs.current];
            let _tabInit = newTabs[0];
            let _tab = newTabs.find(x => x.name === name);
            let index = newTabs.indexOf(_tab)
            if (index > -1) {
                newTabs.splice(index, 1);
            }

            tabs.current = newTabs;

            let actionTab = selectTab2(_tabInit.name);
            props.dispatch(actionTab);

            setComodin(newTabs.length);

        }, 1);
    }

    const onSelectedFromMenu = (name) => {

        console.log("onSelectedFromMenu,", name);

        setTimeout(() => {

            let newTabs = [...tabs.current];



            let _tabInit = newTabs[0];
            let _tab = newTabs.find(x => x.name === name);
            let index = newTabs.indexOf(_tab)
            if (index > -1) {
                newTabs.splice(index, 1);
            }
            newTabs.splice(1, 0, _tab);

            tabs.current = newTabs;

            let actionTab = selectTab2(name);
            props.dispatch(actionTab);
            setComodin(newTabs.length + 1);

        }, 1);
    }



    /*const ConfigurarDataTableGenerica=() =>{
         return (<DataTableGenerica codMenu ={codMenu} idioma = {idioma} idEmpresa = {idEmpresa} selectedTipoGenerica={selectedTipoGenerica}></DataTableGenerica>);
    }*/


    const template = (options) => {
        const toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
        const className = `${options.className} justify-content-start`;
        const titleClassName = `${options.titleClassName} pl-1`;

        return (
            <div className={className}>
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple />
                </button>
                <span className={titleClassName}>
                    Configuraciones asociadas
                </span>
            </div>
        )
    }

    const template2 = (options) => {
        const toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
        const className = `${options.className} justify-content-start`;
        const titleClassName = `${options.titleClassName} pl-1`;

        return (
            <div className={className}>
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple />
                </button>
                <span className={titleClassName}>
                    Datos
                </span>
            </div>
        )
    }

    if (codMenu !== "" && tabs.current.length > 0) {
        return (
            <div className="grid crud-demo" style={{ paddingTop: "1em" }}>
                <div className="col-12" >

                    <BreadcrumbBar tabs2={tabs.current} ref={e => tabContainer = e} comodin={comodin} addSubTabMenu={addSubTabMenu} onAfterDeleteTab={onAfterDeleteTab} onSelectedFromMenu={onSelectedFromMenu} size="massive" />
                </div>

            </div>
        );

        /*
        <div className="col-12">
        <Panel headerTemplate={template} className="card" toggleable>
                    <SplitButton label="Opciones asociadas" model={items} className="p-button-raised mr-2 mb-2"></SplitButton>
                    <Toolbar className="mb-1" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            </Panel></div>*/
    }
    else {
        return (
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        Cargando configuración
                    </div>
                </div>
            </div>
        );
    }
});

/*const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

//export default React.memo(TemplateContent);
*/
export default connect(null)(TemplateContent);